import { useNavigate } from "react-router";
import SideNavbar from "../externals/SideNavbar";
import ExcelDownload from "../externals/ExcelDownload";
import { useEffect, useState } from "react";
import axios from "axios";

function AdminDashboard(){

    var user = window.localStorage.getItem("uName");
    var userNtk = window.localStorage.getItem("userNtk");

    const [adminUser, setAdminUser] = useState("");
    const [role, setUserRole] = useState("user");

    const navigate = useNavigate();

    useEffect(() => {

    axios.post("https://nodeppcbackend-production.up.railway.app/api/allowAccess", {
      Username: user.toString(),
      Signature: userNtk.toString(),
    })
    .then((response) => {
      if (response.data["Access"] === false) {     

        //alert("Trebuie sa va logati din nou!");
        navigate("/Admin");
      }
      else{
        setAdminUser(response.data["Username"]);
        setUserRole(response.data["Role"]);
      }
    })
    .catch((err) => {
     
    });
   }); 

        return(
         <>          
            <SideNavbar username={adminUser} role={role}/>             

        </>
        );
      
    
   
}

export default AdminDashboard;